import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { httpinstance } from "../../axios/api"
// Async thunk for fetching organization list
export const organizationlist = createAsyncThunk('organizationlist', async (queryString) => {
  try {
    let url="";
    if(queryString==="all"){
       url = `org/list_org?status=${queryString}`;
    }else{
     url = `org/list_org?${queryString}`;}
    const response = await httpinstance.get(url);
    return response.data; // Only return the data field
  } catch (err) {
    throw err.response; // Throw the error for better error handling
  }
});
export const getcountry=createAsyncThunk('getcountry',async()=>{
  try{
    const url=`/org/countries`;
    const response =await httpinstance.get(url);
    return response.data;
  }catch(err){
    throw err.response
  }
}) 
export const getcity=createAsyncThunk('getcity',async(value)=>{
  try{
    const url=`/org/cities/${value}`;
    const response =await httpinstance.get(url);
    return response.data;
  }catch(err){
    throw err.response
  }
})
export const categorylist=createAsyncThunk('categorylist',async()=>{
  try{
    const url=`/org/customer_category`;
    const response =await httpinstance.get(url);
    return response.data;
  }catch(err){
    throw err.response
  }
})
export const createorg=createAsyncThunk('createorg',async(value)=>{
  try{
    const url=`/org/create_org`;
    const response =await httpinstance.post(url,value);
    return response.data;
  }catch(err){
    return err.response.data
  }
})
export const updateorg=createAsyncThunk('updateorg',async(value)=>{
  try{
    const url=`/org/update_org`;
    const response =await httpinstance.post(url,value);
    return response.data;
  }catch(err){
    return err.response.data
  }
})
export const userorgupdate=createAsyncThunk('userorgupdate',async(value)=>{
  try{
    const url=`/org/assign-org`;
    const response =await httpinstance.post(url,value);
    return response.data;
  }catch(err){
    return err.response.data
  }
})
// Initial state
const initialState = {
  isOrganizationCreated: false,
  OrganizationData: [], // Default value for organization list
  countrydata:[],
  categorylistdata:[],
  cityData:[],
  updateuserorg:{},
  orgcreate:{},
  orgupdate:{},
};

// Organization slice
const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setOrganizationCreated(state, action) {
      state.isOrganizationCreated = action.payload;
    },
  },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(organizationlist.fulfilled, (state, { payload }) => {
  //       state.OrganizationData = payload; // Mutate state directly
  //     })
  //     .addCase(organizationlist.rejected, (state, action) => {
  //       console.error('Failed to fetch organization list', action.error);
  //     });
  // },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(getcountry.fulfilled, (state, { payload }) => {
  //       state.countrydata = payload; // Mutate state directly
  //     })
  //     .addCase(getcountry.rejected, (state, action) => {
  //       console.error('Failed to fetch organization list', action.error);
  //     });
  // },
  // extraReducers:(builder)=>{
  //   builder.addCase(categorylist.fulfilled, (state, { payload }) => {
  //     state.categorylistdata = payload; // Mutate state directly
  //   }).addCase(categorylist.rejected, (state, action) => {
  //     console.error('Failed to fetch organization list', action.error);
  //   })
  // },
  // extraReducers:(builder)=>{
  //   builder.addCase(getcity.fulfilled, (state, { payload }) => {
  //     state.cityData = payload; // Mutate state directly
  //   }).addCase(getcity.rejected, (state, action) => {
  //     console.error('Failed to fetch organization list', action.error);
  //   })
  // },
  // extraReducers:(builder)=>{
  //   builder.addCase(createorg.fulfilled, (state, { payload }) => {
  //     state.createorg = payload; // Mutate state directly
  //   }).addCase(createorg.rejected, (state, action) => {
  //     console.error('Failed to fetch organization list', action.error);
  //   })
  // }
  // ,
  // extraReducers:(builder)=>{
  //   builder.addCase(updateorg.fulfilled, (state, { payload }) => {
  //     state.updateorg = payload; // Mutate state directly
  //   }).addCase(updateorg.rejected, (state, action) => {
  //     console.error('Failed to fetch organization list', action.error);
  //   })
    
  // }
  extraReducers: (builder) => {
    builder
      .addCase(organizationlist.fulfilled, (state, { payload }) => {
        state.OrganizationData = payload;
      })
      .addCase(getcountry.fulfilled, (state, { payload }) => {
        state.countrydata = payload;
      })
      .addCase(categorylist.fulfilled, (state, { payload }) => {
        state.categorylistdata = payload;
      })
      .addCase(getcity.fulfilled, (state, { payload }) => {
        state.cityData = payload;
      })
      .addCase(createorg.fulfilled, (state, { payload }) => {
        state.createorg = payload;
      })
      .addCase(updateorg.fulfilled, (state, { payload }) => {
        state.updateorg = payload;
      })  .addCase(userorgupdate.fulfilled, (state, { payload }) => {
        state.updateuserorg = payload;
      })
      // Handle other rejected cases if necessary
      .addCase(organizationlist.rejected, (state, action) => {
        console.error('error in organization section', action.error);
      });
  },
})


// Export actions and reducer
export const { setOrganizationCreated } = organizationSlice.actions;
export default organizationSlice.reducer;
